import { API } from "./Interceptor";

export const updateUserStatus = async (status, projectId, userId) => {
  const payload = {
    status,
    jobId: projectId,
    userId: Number.isFinite(Number(userId)) ? Number(userId) : userId,
  };
  try {
    const res = await API.put("api/jobs/status", payload, {
      skipErrorToast: true,
    });
    return res?.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
